import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import messageIcon from "../../assets/images/kind-message-icon.png";
import redAlertIcon from "../../assets/images/red-alert-icon.png";
import arrowDownIcon from "../../assets/images/arrow-down-white.png";
import arrowUpIcon from "../../assets/images/arrow-up-white.png";
import { convertMonth } from "../../utils/helpers/monthConverter";
import {
  dateDayFormat,
  dateFormatter,
} from "../../utils/helpers/dateFormatter";

const MessageOption = (props: { depositMessage: any }) => {
  const { t, i18n } = useTranslation("common");
  const [isExpanded, setExpanded] = useState(false);

  const handleClick = () => {
    setExpanded((prevExpanded) => !prevExpanded);
  };

  const getDepTotal = () => {
    if (props.depositMessage) {
      return (
        props?.depositMessage?.depEmployeeSum +
        props?.depositMessage?.depEmployerSum +
        props?.depositMessage?.depCompensationSum +
        props?.depositMessage?.depDifferentSum
      );
    }
  };

  return (
      <li className="letters-reports-details">
        <div className="letters-reports-details-right">
          <div className="d-flex align-items-center">
            <img src={messageIcon} alt="" />
            <span className="letters-right-status-label">
              {t("LettersReports.message")}
            </span>
            <span className="line">| </span>
            <span className="letters-left-date">
              {dateFormatter(props.depositMessage.depositDate)}
            </span>
          </div>
          <div className="d-flex align-items-center alert-rmv-padding">
            <img src={redAlertIcon} alt="alert" />
            <span className="letters-right-message-label">
              {t("LettersReports.missingMessage")} - {props.depositMessage.fundNameHeb}
            </span>
          </div>
          <span className="letters-right-attention-label">
            {t("LettersReports.attention")}
          </span>
          {isExpanded && (
            <>
              <span className="right-attention-expanded-label">
                {`${t("MessageOption.firstLabel1")} ${convertMonth(
                  parseInt(
                    props.depositMessage.salaryDate.split("T")[0].split("-")[1]
                  ),
                  i18n.language
                )} ${t("MessageOption.firstLabel2")} ${getDepTotal().toFixed(2)} ${t(
                  "MessageOption.firstLabel3"
                )}
                ${t("MessageOption.firstLabel4")} ${dateDayFormat(
                  props.depositMessage.depositDate
                )}
                ${t("MessageOption.firstLabel5")} 0.00 ${t(
                  "MessageOption.firstLabel6"
                )}
                `}
              </span>
              <span className="right-attention-expanded-label">
                {t("MessageOption.secondLabel")}
              </span>
              <span className="right-attention-expanded-label">
                {t("MessageOption.thirdLabel1")}
                <span className="right-attention-expanded-number">
                  <a
                    className="right-attention-expanded-number"
                    href={`tel:${t("MessageOption.thirdLabel2")};postd=#`}
                    style={{ textDecoration: "none" }}
                  >
                    {t("MessageOption.thirdLabel2")}
                  </a>
                </span>
              </span>
            </>
          )}
        </div>
        <div className="letters-reports-details-left">
          <button className="letters-left-more-details" onClick={handleClick}>
            {!isExpanded ? (
              <>
                <span>{t("general.moreDetails")}</span>
                <img src={arrowDownIcon} alt="arrow" />
              </>
            ) : (
              <>
                <span>{t("general.close")}</span>
                <img src={arrowUpIcon} alt="arrow" />
              </>
            )}
          </button>
        </div>
    </li>
  );
};

export default MessageOption;
